export const CreateActionTypeIs = (preText: string, text: string) => {
    return `${preText}${text}`;
};

export interface ExecuteWithTimeoutOptions<T> {
  apiCall: () => Promise<T>;
  timeoutMs: number;
  onTimeout: () => void;
  onSuccess: (res: T) => void;
  onError: (err: any) => void;
}

/**
 * Thực thi một cuộc gọi API kèm theo thời gian chờ tối đa (timeoutMs).
 * Nếu API phản hồi trước timeoutMs -> gọi onSuccess hoặc onError.
 * Nếu vượt quá timeoutMs -> gọi ngay onTimeout.
 */
export const executeWithTimeout = async <T>(options: ExecuteWithTimeoutOptions<T>) => {
  const { apiCall, timeoutMs, onTimeout, onSuccess, onError } = options;
  let isHandled = false;

  const timer = setTimeout(() => {
    if (!isHandled) {
      isHandled = true;
      onTimeout();
    }
  }, timeoutMs);

  try {
    const res = await apiCall();
    if (!isHandled) {
      isHandled = true;
      clearTimeout(timer);
      onSuccess(res);
    }
  } catch (err: any) {
    if (!isHandled) {
      isHandled = true;
      clearTimeout(timer);
      onError(err);
    }
  }
};